var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidedTourLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 194,
    viewBox: "0 0 232 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7184 99.353C56.3222 88.2937 60.118 74.1522 71.1964 67.7671L113.321 43.4884C124.399 37.1033 138.565 40.8925 144.961 51.9518L169.282 94.0037C175.678 105.063 171.882 119.205 160.804 125.59L118.679 149.868C107.601 156.253 93.4351 152.464 87.039 141.405L62.7184 99.353Z",
    fill: "#E5F9F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.028 96.6791C159.705 96.6791 168.361 88.0382 168.361 77.3791C168.361 66.72 159.705 58.0791 149.028 58.0791C138.35 58.0791 129.694 66.72 129.694 77.3791C129.694 88.0382 138.35 96.6791 149.028 96.6791Z",
    fill: "#43D2A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.531 73.4089L147.259 86.6589L138.221 77.6366L141.638 74.2248L147.259 79.8353L157.114 69.9971L160.531 73.4089Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4182 28.0692C39.1228 23.6286 48.9745 26.2639 53.4227 33.9551C57.871 41.6464 55.2312 51.4811 47.5266 55.9217C39.8221 60.3622 29.9704 57.727 25.5221 50.0358C21.0739 42.3445 23.7137 32.5097 31.4182 28.0692Z",
    fill: "#E5F9F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6809 39.3472L38.6668 46.3492L34.875 42.5639L36.0142 41.4266L38.6668 44.0747L44.5417 38.21L45.6809 39.3472Z",
    fill: "#00C78D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.057 26.8331C188.22 23.2807 196.102 25.3888 199.66 31.5418C203.219 37.6948 201.107 45.5626 194.944 49.1151C188.78 52.6675 180.899 50.5593 177.34 44.4063C173.781 38.2533 175.893 30.3855 182.057 26.8331Z",
    fill: "#E5F9F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.581 35.9693L187.855 41.6846L184.708 38.5426L185.847 37.4054L187.855 39.4101L192.441 34.832L193.581 35.9693Z",
    fill: "#00C78D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0853 136.258C50.3307 130.93 62.1528 134.092 67.4907 143.322C72.8286 152.551 69.6608 164.353 60.4154 169.681C51.1699 175.01 39.3478 171.848 34.01 162.618C28.6721 153.389 31.8398 141.587 41.0853 136.258Z",
    fill: "#E5F9F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0869 149.678L49.7839 157.967L45.3477 153.538L46.4869 152.401L49.7839 155.692L56.9477 148.541L58.0869 149.678Z",
    fill: "#00C78D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.083,
    y: 70.1416,
    width: 43.5,
    height: 8.04167,
    rx: 2,
    fill: "#FF7C81"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.083,
    y: 121.608,
    width: 43.5,
    height: 8.04167,
    rx: 2,
    fill: "#FF7C81"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1943 99.8961C77.1389 107.985 72.4783 112.802 71.6943 121.609H111.972C110.716 113.166 105.968 108.413 98.2777 99.8961C106.064 91.9679 110.481 87.1383 111.972 78.1836H71.6943C73.2528 86.7323 77.736 92.6586 86.1943 99.8961Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.833 101.504C91.833 101.504 77.333 112.679 77.333 118.391H106.333C106.333 112.679 91.833 101.504 91.833 101.504Z",
    fill: "#66AFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedTourLoading);
export default __webpack_public_path__ + "static/media/guided-tour-loading.de09f92f04b90b59ca15cb4fc04febea.svg";
export { ForwardRef as ReactComponent };